export default __webpack_public_path__ + "static/media/020-mathematics.55c60aac.svg";